import {
  buildSalesOrderSearchPayload,
  salesOrderDocumentsSearchConfig,
} from 'Views/SearchSaleOrder/searchSalesOrderDocuments.config'
import { quoteFilterFields } from 'Views/SearchQuote/searchQuoteDocuments.config'

export const webSalesOrderInitialFilters = {
  ...salesOrderDocumentsSearchConfig.initialFilters,
  salesAgentId: null,
  warehouseIds: null,
  allWarehouses: true,
}

// allWarehouses only sets the default selection; any user can still pick any branch.
export function getDefaultWebSalesOrderWarehouseIds(filters) {
  return filters.allWarehouses || !filters.warehouseId
    ? []
    : [filters.warehouseId]
}

export function getWebSalesOrderWarehouseIds(filters) {
  return filters.warehouseIds ?? getDefaultWebSalesOrderWarehouseIds(filters)
}

export function buildWebSalesOrderSearchPayload(filters) {
  const warehouseIds = getWebSalesOrderWarehouseIds(filters)
  return {
    ...buildSalesOrderSearchPayload(filters),
    salesAgentId: filters.salesAgentId || undefined,
    warehouseIds: warehouseIds.length ? warehouseIds : undefined,
    origin: 'AB',
  }
}

export const webSalesOrderFilterFields = [
  {
    key: 'salesOrderNumber',
    i18nKey: 'SEARCH_QUOTATION_T.NUMBER_SALE_ORDER_LABEL',
    testId: 'input-salesorderid-filter',
  },
  ...quoteFilterFields,
]
